'use client'
import { siteConfig } from '@/config/site'
import Link from '@/components/link-locale'
import { Login } from '@/lib/api/hooks/use-account'
import { Button, Checkbox, Flex, Form, Input, Spin } from 'antd'
import { useTranslations } from 'next-intl'
import React from 'react'

export default function LoginForm() {
  const t = useTranslations()

  const { mutateAsync: login, isPending } = Login()

  const spinning = isPending

  const initialValues = {
    email: '',
    password: '',
  }

  const onFormFinish = async values => {
    await login(values)
  }

  return (
    <>
      <Form
        layout='vertical'
        colon={false}
        initialValues={initialValues}
        onFinish={onFormFinish}
      >
        <Form.Item
          label={t('common.email')}
          name='email'
          rules={[{ required: true }, { type: 'email' }]}
        >
          <Input
            className='h-10 text-sm font-normal'
            showCount={true}
            maxLength={siteConfig.validation.email.maxLength}
            autoComplete='email'
          />
        </Form.Item>
        <Form.Item
          label={t('common.password')}
          name='password'
          rules={[
            { required: true },
            { type: 'string', min: siteConfig.validation.password.min, max: siteConfig.validation.password.max },
            {
              pattern: siteConfig.validation.password.pattern,
              message: t('error.passwordPattern'),
            },
          ]}
        >
          <Input.Password
            className='h-10 text-sm font-normal'
            maxLength={20}
            showCount={true}
            autoComplete='new-password'
          />
        </Form.Item>
        <Form.Item>
          <Flex justify='space-between'>
            <Checkbox>{t('page.login.rememberMe')}</Checkbox>
            <Link
              href='/forgot-password'
              className='text-xs text-[#A9A9A9] hover:text-[#FF3C8E]'
            >
              {t('common.forgotPassword')}
            </Link>
          </Flex>
        </Form.Item>
        <Form.Item>
          <Button
            type='primary'
            htmlType='submit'
            block={true}
            className='h-12 text-base font-semibold'
          >
            {t('common.login')}
          </Button>
        </Form.Item>
      </Form>
      <Spin spinning={spinning} fullscreen={true} />
    </>
  )
}
